<template>
  <div class="challenge_popup" v-if="picked">
    <div class="challenge_popup_wrapper">
      <div class="popup_content">
        <button class="popup_close" @click="close()">
          <i class="fas fa-times"></i>
        </button>
        <div class="slider">
          <button
            class="slider_pre"
            v-if="current != 0"
            @click="current != -0 ? current-- : current"
          >
            <i class="fas fa-arrow-left"></i>
          </button>
          <div class="slider_main">
            <p class="img">
              <img :src="picked.images[current]" :alt="`${current + 1}枚目`" />
            </p>
          </div>
          <button
            class="slider_next"
            v-if="current != picked.images.length - 1"
            @click="current != picked.images.length - 1 ? current++ : current"
          >
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>
      <div class="popup_detail">
        <div class="popup_header">
          <p class="popup_title">{{ picked.index }}枚目</p>
          <!-- <button class="popup_edit">編集</button> -->
        </div>
        <div class="popup_caption">
          <p>{{ picked.caption }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["picked"],
  data() {
    return {
      current: 0,
    };
  },
  methods: {
    close() {
      this.current = 0;
      this.$emit("pickup", null);
    },
  },
};
</script>

<style lang="scss">
.challenge {
  &_popup {
    position: fixed;
    height: 120vh;
    width: 100%;
    background-color: #000000f0;
    top: 0;
    left: 0;
    @include zIndex(101);
    &_wrapper {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
    }
    .popup {
      &_close {
        position: absolute;
        top: 0;
        right: 0;
        @include icon(14px);
        @include zIndex(100);
        padding: 20px;
        color: #fff;
        margin: 16px;
        backdrop-filter: blur(2px);
        background-color: #0000008a;
        @include flex_c();
        i {
          @include fz(18);
        }
      }
      &_content {
        height: 80%;
        @include flex_c();
        .slider {
          position: relative;
          &_pre,
          &_next {
            position: absolute;
            top: calc(50% - 20px);
            backdrop-filter: blur(5px) invert(20%);
            height: 40px;
            width: 40px;
            @include flex_c;
            border-radius: 20px;
            i {
              @include fz(18);
            }
            @include pc {
              &:hover {
                background-color: $fade_color;
              }
            }
          }
          &_pre {
            left: 2.3vw;
          }
          &_next {
            right: 2.3vw;
          }
          &_main {
            padding: 2%;
          }
        }
      }
      &_detail {
        position: absolute;
        background-color: #0000008a;
        color: #fff;
        width: 100%;
        bottom: 20vh;
        left: 0;
        padding: 20px 20px 40px;
      }
      &_header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
      }
      &_title {
        border-radius: 30px;
        background-color: #fff;
        color: #000;
        padding: 4px 14px;
      }
      &_edit {
        @include fz(16);
        border: 1px solid #fff;
        padding: 2px 14px;
        border-radius: 4px;
      }
    }
  } //クリックでキャプションの表示をトグル
} //challenge
</style>